export default "__VITE_ASSET__D1V161ra__"